import PropTypes, { object } from 'prop-types';
// form
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import { TextField, Autocomplete, Chip } from '@mui/material';

// ----------------------------------------------------------------------

export default function RHFAutocomplete({
  name,
  options = [],
  label,
  placeholder,
  multiple = true,
  renderTags,
  onChange = () => {},
  captureInput,
  onTextChange = () => {},
  renderInputProps,
  ...other
}) {
  const { control } = useFormContext();

  // Suggestion: add an option to accept an object with a value and label property for the 'options' prop

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <Autocomplete
          {...field}
          {...other}
          multiple={multiple}
          freeSolo={captureInput}
          onChange={(event, newValue) => {
            field.onChange(newValue);
            onChange(event, newValue);
          }}
          options={options?.map((option) => option)}
          renderTags={
            renderTags // eslint-disable-line no-unneeded-ternary
              ? renderTags
              : (value, getTagProps) =>
                  value.map((option, index) => {
                    if (option?.label)
                      return <Chip {...getTagProps({ index })} key={option.value} size="small" label={option.label} />;

                    if (typeof option === 'string')
                      return <Chip {...getTagProps({ index })} key={option} size="small" label={option} />;

                    if (typeof option === 'object') {
                      const val = Object.entries(option)[0];
                      return (
                        <Chip
                          {...getTagProps({ index })}
                          key={`${name}-${index}`}
                          size="small"
                          label={`${val[0]}:${val[1]}`}
                        />
                      );
                    }

                    return <Chip {...getTagProps({ index })} key={index} size="small" label={`Loading...`} />;
                  })
          }
          renderInput={(params) => (
            <TextField
              onChange={
                (captureInput &&
                  ((event) => {
                    field.onChange(event.target.value);
                  }),
                onTextChange &&
                  ((event) => {
                    onTextChange(event, event.target.value);
                  }))
              }
              label={label}
              placeholder={placeholder}
              error={!!error}
              helperText={error?.message}
              {...params}
              InputLabelProps={{ shrink: true }}
              {...renderInputProps}
            />
          )}
        />
      )}
    />
  );
}
